// import { Outlet, Navigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';

// const PrivateRoutes = () => {
//   const user = useSelector((state) => state.user.user);
//   const token = user?.token;

//   const TOKEN = () => {
//     if (token) {
//       return user;
//     } else {
//       return '';
//     }
//   };

//   return !TOKEN() ? <Navigate to='/' /> : <Outlet />;
// };

// export default PrivateRoutes;
import { Outlet, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { API_Link, ValidateHeader } from '../common/Constants';
import { useEffect } from 'react';
import axios from 'axios';

const PrivateRoutes = ({ dRole }) => {
  const user = useSelector((state) => state.user.user);

  const isEmpty = user && Object.values(user)?.some((value) => value === '');
  const TOKEN = () => {
    // if (!isEmpty && user && user?.role?.role === dRole) {
    if (!isEmpty && user) {
      return user;
    } else {
      return '';
    }
  };


  // useEffect(() => {
  //       if (!TOKEN()) return;
 
  //       axios({
  //           method: "post",
  //           url: `${API_Link}updateEsResults`,
  //           headers: {
  //               "Content-Type": "application/json",
  //               Accept: "application/json",
  //               "plims-auth": ValidateHeader,
  //               Authorization: `Bearer ${user?.token}`,
  //           },
  //       }).catch(() => {});
 
  //   }, [user?.token]);

  return !TOKEN() ? <Navigate to='/' /> : <Outlet />;
};

export default PrivateRoutes;
